import { TABLEAU_POD_URL } from '@src/utils/hooks/tableau/tableau-constants';

export const AMC_TABLEAU_DASHBOARD_URL = `${TABLEAU_POD_URL}/t/tinuiti/views/WIPPTPathingAnalysisDashboardV3/CampaignPath`;
